import { combineReducers } from 'redux';
import details, { DetailsState } from './details';
import config, { ConfigState } from './config';
import productAnalytics, { ProductAnalyticsState } from './productAnalytics';
import branding, { BrandingState } from './branding';

export interface OrganizationState {
  details: DetailsState
  config: ConfigState
  productAnalytics: ProductAnalyticsState
  branding: BrandingState
}

export default combineReducers({
  details,
  config,
  productAnalytics,
  branding,
});
